import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import Headline6 from '../Typography/Heading/Headline6';
import breakpoints from '../Theme/breakpoints';

const filterHeadingPropertyTypes = {
  modal: PropTypes.bool,
};

type FilterHeadingProperties = InferProps<typeof filterHeadingPropertyTypes>;

const FilterHeading = styled(Headline6)<FilterHeadingProperties>`
  flex: 1 0 90%;
  margin: 0 0 4px;
  padding: ${({ modal }) => (modal ? '0' : '0px 16px')};
  letter-spacing: -1px;

  @media (min-width: ${breakpoints.md}px) {
    padding: 0;
    margin: 0 0 8px;
    margin: ${({ modal }) => (modal ? '0 0 8px' : '0px')};
  }
`;

FilterHeading.propTypes = filterHeadingPropertyTypes;

export default FilterHeading;
